import * as types from '../actions/types';

const initialState = {
    category: "all",
    page:1,
    success: false
}

export default function PgmcategorydataReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.PGM_CATEGORY:
            return {
                ...state,
                category: action.payload,
                success: true
            }
        case types.PGM_PAGE:
            return {
                ...state,
                page: action.payload,
                success: true
            }
        default:
            return state
    }
}
